module.exports = __webpack_public_path__ + "static/media/logo-image.865b8a53.png";